export const getTotalPages = (total: number, pageSize: number) => {
  return total === 0 ? 0 : Math.ceil(total / pageSize);
};
